import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export function useSearchParams() {
  const history = useHistory();
  const location = useLocation();

  const get = useCallback(
    (key: string) => {
      const search = new URLSearchParams(location.search);
      return search.get(key) || undefined;
    },
    [location.search],
  );

  const set = useCallback(
    (key: string, value: string) => {
      const search = new URLSearchParams(location.search);
      search.set(key, value);
      history.replace({
        search: search.toString(),
      });
    },
    [history, location.search],
  );

  const remove = useCallback(
    (key: string) => {
      const search = new URLSearchParams(location.search);
      search.delete(key);
      history.replace({
        search: search.toString(),
      });
    },
    [history, location.search],
  );

  const batch = useCallback(
    (fn: (search: URLSearchParams) => void) => {
      const search = new URLSearchParams(location.search);
      fn(search);
      history.replace({
        search: search.toString(),
      });
    },
    [history, location.search],
  );

  return {
    get,
    set,
    delete: remove,
    batch,
  };
}
